import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesStatusesGetAsyncSlice } from './get';

export const coreInitiativesStatusesReducers = combineReducers({
	get: coreInitiativesStatusesGetAsyncSlice.asyncReducers
});

export const coreInitiativesStatusesWatches = combineAllWatchers([
	coreInitiativesStatusesGetAsyncSlice.asyncWatchers
]);
